import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    prompts: {
        data: [],
        loading: false,
        error: null,
        total: 0,
    },
    promptDetails: null,
    guestQuota: {
        genericLeaderPromptsViewed: 0,
        limit: 5,
        quotaExceeded: false,
    },
    promptViews: {
        count: 0,
        seenIds: {},
        feedbackShown: false,
    },
    loading: false,
    error: null,
};

const leaderInsightSlice = createSlice({
    name: "leaderInsight",
    initialState,
    reducers: {
        fetchLeaderInsightPromptsStart: (state) => {
            state.prompts.loading = true;
            state.prompts.error = null;
        },
        fetchLeaderInsightPromptsSuccess: (state, action) => {
            state.prompts.loading = false;
            state.prompts.data = action.payload.data || [];
            state.prompts.total = action.payload.total || 0;
        },
        fetchLeaderInsightPromptsFail: (state, action) => {
            state.prompts.loading = false;
            state.prompts.error = action.payload;
        },

        fetchLeaderInsightPromptStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchLeaderInsightPromptSuccess: (state, action) => {
            state.loading = false;
            state.promptDetails = action.payload;
            if (action.payload.guestQuota) {
                state.guestQuota = action.payload.guestQuota;
            }
            if (action.payload?._id) {
                state.promptViews.seenIds[action.payload._id] = true;
            }
        },
        fetchLeaderInsightPromptFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        reactToLeaderInsightDataModalStart: (state) => {
            state.loading = true;
        },
        reactToLeaderInsightDataModalSuccess: (state, action) => {
            state.loading = false;
            const { dataModalID, reaction } = action.payload;
            if (state.promptDetails?.dataModals?.length) {
                const modal = state.promptDetails.dataModals.find(
                    (dm) => dm._id === dataModalID
                );
                if (modal) {
                    modal.reaction = reaction;
                }
            }
        },
        reactToLeaderInsightDataModalFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        favouriteLeaderInsightPromptStart: (state) => {
            state.loading = true;
        },
        favouriteLeaderInsightPromptSuccess: (state, action) => {
            state.loading = false;
            const { interaction: payload } = action.payload;
            if (!payload && state.promptDetails) {
                state.promptDetails.isFavourited = false;
                return;
            }
            if (payload?.favourite !== undefined && state.promptDetails) {
                state.promptDetails.isFavourited = payload.favourite;
            }
        },
        favouriteLeaderInsightPromptFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        clearLeaderInsightPrompt: (state) => {
            state.promptDetails = null;
            state.error = null;
        },

        setLeaderInsightGuestQuotaExceeded: (state, action) => {
            const { genericLeaderPromptsViewed, limit } = action.payload || {};
            state.guestQuota = {
                genericLeaderPromptsViewed:
                    genericLeaderPromptsViewed ||
                    state.guestQuota.genericLeaderPromptsViewed,
                limit: limit || state.guestQuota.limit,
                quotaExceeded: true,
            };
        },
        resetLeaderInsightGuestQuota: (state) => {
            state.guestQuota = {
                genericLeaderPromptsViewed: 0,
                limit: 5,
                quotaExceeded: false,
            };
        },

        trackLeaderInsightView: (state, { payload }) => {
            const id = payload?.promptID;
            if (!id) return;
            if (state.promptViews.seenIds[id]) return;
            state.promptViews.seenIds[id] = true;
            state.promptViews.count += 1;
        },
        markLeaderInsightFeedbackShown: (state) => {
            state.promptViews.feedbackShown = true;
        },
    },
});

export const {
    fetchLeaderInsightPromptsStart,
    fetchLeaderInsightPromptsSuccess,
    fetchLeaderInsightPromptsFail,
    fetchLeaderInsightPromptStart,
    fetchLeaderInsightPromptSuccess,
    fetchLeaderInsightPromptFail,
    reactToLeaderInsightDataModalStart,
    reactToLeaderInsightDataModalSuccess,
    reactToLeaderInsightDataModalFail,
    favouriteLeaderInsightPromptStart,
    favouriteLeaderInsightPromptSuccess,
    favouriteLeaderInsightPromptFail,
    clearLeaderInsightPrompt,
    setLeaderInsightGuestQuotaExceeded,
    resetLeaderInsightGuestQuota,
    trackLeaderInsightView,
    markLeaderInsightFeedbackShown,
} = leaderInsightSlice.actions;

export default leaderInsightSlice.reducer;
